import React from 'react'

import Section from 'component/Section'
import SectionContent from 'component/SectionContent'
import SectionHeader from 'component/SectionHeader'
import SectionSplit from 'component/SectionSplit'
import SectionSplitWrapper from 'component/SectionSplitWrapper'
import SocialLinks from 'component/SocialLinks'
import Faq from 'component/FAQ'

const FaqSection = () => {
	return (
		<Section theme="faq">
			<SectionSplitWrapper>
				<SectionSplit size="30">
					<SectionHeader
						title={
							<>
								Você tem alguma <br className="desktop" /> dúvida? Consulte o{' '}
								<br className="desktop" /> nosso FAQ :)
							</>
						}
						titleHeadingSize="3"
						titleHeadingLevel="2"
					/>
					<SectionContent>
						{/* <Anchor href="/">Acesse nosso FAQ completo.</Anchor> */}
						<SocialLinks theme="desktop" />
					</SectionContent>
				</SectionSplit>
				<SectionSplit size="70">
					<Faq
						items={[
							{
								id: 1,
								title: 'O que é software jurídico?',
								text: (
									<>
										Software jurídico é um programa de computador desenvolvido
										para atender operadores do direito em diferentes segmentos.
										Advogados autônomos, escritórios de todos os tamanhos e
										departamentos jurídicos de empresas estão entre os
										principais usuários de softwares jurídicos.
									</>
								),
							},
							{
								id: 2,
								title: 'Qual o melhor software jurídico?',
								text: (
									<>
										O melhor software jurídico é capaz de automatizar e integrar
										a rotina jurídica do escritório e do advogado do início ao
										fim, desde a aquisição de clientes até o encerramento dos
										processos e casos. O Astrea e o Themis são dois exemplos.
										Com mais de 100.000 clientes em 2023, o Astrea é o software
										jurídico mais usado e indicado entre os advogados - 90% das
										pessoas que o utilizam indicariam o sistema com certeza.
									</>
								),
							},
							{
								id: 3,
								title: 'Quanto custa um software jurídico? ',
								text: (
									<>
										Os planos iniciais de um programa jurídico com um bom
										custo-benefício variam de R$0 a R$1.000 mensais. O software
										Astrea, por exemplo, conta com um plano inicial gratuito por
										1 ano, e planos pagos que variam entre R$207 e R$927, além
										de opções de planos sob consulta.
									</>
								),
							},
							{
								id: 4,
								title: 'O que é Aurum?',
								text: (
									<>
										A Aurum é a empresa que desenvolve os softwares jurídicos
										Astrea – para advogados autônomos, pequenos e médios
										escritórios – e o Themis – para grandes bancas e
										departamentos jurídicos. Está há mais de 25 anos no mercado
										e é certificada 4 anos consecutivos pelo selo Great Place
										Work® como uma das melhores empresas para se trabalhar no
										Brasil.
									</>
								),
							},
						]}
					/>
					<SocialLinks theme="mobile" />
				</SectionSplit>
			</SectionSplitWrapper>
		</Section>
	)
}

export default FaqSection
